import React from "react";
import { Form, Button, Alert } from "react-bootstrap";
import { _t } from "../../app/i18n/i18n";
import { NomuraLogo } from "./NomuraLogo";
import { LinkContainer } from "react-router-bootstrap";

export const ForgottenPwdSent = () => (
  <section className="w-100 screen-height text-white bg-dark p-5">
    <Form className="maxw-600">
      <NomuraLogo />

      <Alert variant="info">
        <Alert.Heading>{_t("Please check your email")}</Alert.Heading>
        {_t(
          "Instructions to reset your password will be sent to the email address specified, if this email address is associated with a valid account"
        )}
        <br />
        <b>{""}</b>
      </Alert>

      <LinkContainer to={"/public/login"}>
        <Button variant="outline-light my-3" className="w-100 more-border-radius">
          {_t("Return to Login Page")}
        </Button>
      </LinkContainer>
    </Form>
  </section>
);
